import React, { useState } from 'react';

import GiftFormSearch from '@/pages/gift-management/components/GiftFormSearch';
import GiftList from '@/pages/gift-management/components/GiftList';
import GiftTopHeader from '@/pages/gift-management/components/GiftTopHeader';

const GiftManagementPage: React.FC = () => {
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <GiftTopHeader />
      <GiftFormSearch onSearch={() => setSearchTrigger((prev) => prev + 1)} />
      <GiftList searchTrigger={searchTrigger} />
    </>
  );
};

export default GiftManagementPage;
